var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-tabs",
        [
          _c(
            "b-tab",
            { attrs: { title: "My Leaves", active: "" } },
            [
              _c(
                "b-row",
                _vm._l(_vm.leaveBalance, function (item, index) {
                  return _c(
                    "b-col",
                    { key: index, attrs: { col: "12", sm: "4", id: index } },
                    [
                      _c(
                        "b-card",
                        { staticClass: "earnings-card" },
                        [
                          _c(
                            "b-card-body",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                            },
                            [
                              _c("div", { staticClass: "truncate" }, [
                                _c(
                                  "h4",
                                  { staticClass: "mb-25 font-weight-bolder" },
                                  [_vm._v(" " + _vm._s(item.title) + " ")]
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "h3",
                                  { staticClass: "mb-25 font-weight-bolder" },
                                  [_vm._v(" " + _vm._s(item.balance) + " ")]
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "b-row",
                [
                  _c("b-table", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false",
                      },
                    ],
                    attrs: {
                      responsive: "sm",
                      fields: _vm.fields,
                      items: _vm.employeeLeaves,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "My Subordinate Leaves" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "my-1",
                              attrs: { md: "2", sm: "4" },
                            },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "mb-0" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "d-inline-block text-sm-left mr-50",
                                    },
                                    [_vm._v("Per page")]
                                  ),
                                  _c("b-form-select", {
                                    staticClass: "w-50",
                                    attrs: {
                                      id: "perPageSelect",
                                      size: "sm",
                                      options: _vm.pageOptions,
                                    },
                                    model: {
                                      value: _vm.perPage,
                                      callback: function ($$v) {
                                        _vm.perPage = $$v
                                      },
                                      expression: "perPage",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "my-1",
                              attrs: { md: "4", sm: "8" },
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    label: "Sort",
                                    "label-cols-sm": "3",
                                    "label-align-sm": "right",
                                    "label-size": "sm",
                                    "label-for": "sortBySelect",
                                  },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    { attrs: { size: "sm" } },
                                    [
                                      _c("b-form-select", {
                                        staticClass: "w-75",
                                        attrs: {
                                          id: "sortBySelect",
                                          options: _vm.sortOptions,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("-- none --")]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value: _vm.sortBy,
                                          callback: function ($$v) {
                                            _vm.sortBy = $$v
                                          },
                                          expression: "sortBy",
                                        },
                                      }),
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "w-25",
                                          attrs: {
                                            size: "sm",
                                            disabled: !_vm.sortBy,
                                          },
                                          model: {
                                            value: _vm.sortDesc,
                                            callback: function ($$v) {
                                              _vm.sortDesc = $$v
                                            },
                                            expression: "sortDesc",
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: false } },
                                            [_vm._v("Asc")]
                                          ),
                                          _c(
                                            "option",
                                            { domProps: { value: true } },
                                            [_vm._v("Desc")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "my-1", attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    label: "Filter",
                                    "label-cols-sm": "3",
                                    "label-align-sm": "right",
                                    "label-size": "sm",
                                    "label-for": "filterInput",
                                  },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    { attrs: { size: "sm" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "filterInput",
                                          type: "search",
                                          placeholder: "Type to Search",
                                        },
                                        model: {
                                          value: _vm.filter,
                                          callback: function ($$v) {
                                            _vm.filter = $$v
                                          },
                                          expression: "filter",
                                        },
                                      }),
                                      _c(
                                        "b-input-group-append",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { disabled: !_vm.filter },
                                              on: {
                                                click: function ($event) {
                                                  _vm.filter = ""
                                                },
                                              },
                                            },
                                            [_vm._v(" Clear ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("b-table", {
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  responsive: "",
                                  "per-page": _vm.perPage,
                                  "current-page": _vm.currentPage,
                                  items: _vm.displayedItems,
                                  fields: _vm.employee_leave_balance_fields,
                                  "sort-by": _vm.sortBy,
                                  "sort-desc": _vm.sortDesc,
                                  "sort-direction": _vm.sortDirection,
                                  filter: _vm.filter,
                                  "filter-included-fields": _vm.filterOn,
                                },
                                on: {
                                  "update:sortBy": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sort-by": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sortDesc": function ($event) {
                                    _vm.sortDesc = $event
                                  },
                                  "update:sort-desc": function ($event) {
                                    _vm.sortDesc = $event
                                  },
                                  filtered: _vm.onFiltered,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(employeeID)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getSubsName(data.item)) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(actions)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.ViewSubordinate(
                                                  data.item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              attrs: { icon: "EyeIcon" },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "align-middle ml-50",
                                              },
                                              [_vm._v("View")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-modal",
                            {
                              ref: "modalSubsdetails",
                              attrs: {
                                id: "modal-view-subd",
                                title: "View Subordinate Leaves",
                                size: "lg",
                                "hide-footer": "",
                                centered: "",
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { md: "12" } }, [
                                    _c(
                                      "h3",
                                      {
                                        staticClass: "mb-25 font-weight-bolder",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getSubsName(
                                                _vm.viewSubs.employeeID
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-row",
                                        _vm._l(
                                          _vm.getSubsLeaves(
                                            _vm.viewSubs.employeeID
                                          ),
                                          function (item, index) {
                                            return _c(
                                              "b-col",
                                              {
                                                key: index,
                                                attrs: { md: "4", id: index },
                                              },
                                              [
                                                _c(
                                                  "b-card",
                                                  {
                                                    staticClass:
                                                      "earnings-card",
                                                  },
                                                  [
                                                    _c(
                                                      "b-card-body",
                                                      {
                                                        staticClass:
                                                          "d-flex justify-content-between align-items-center",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "truncate",
                                                          },
                                                          [
                                                            _c(
                                                              "h4",
                                                              {
                                                                staticClass:
                                                                  "mb-25 font-weight-bolder",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.title
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("div", [
                                                          _c(
                                                            "h3",
                                                            {
                                                              staticClass:
                                                                "mb-25 font-weight-bolder",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.balance
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-table", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: false,
                                            expression: "false",
                                          },
                                        ],
                                        attrs: {
                                          responsive: "sm",
                                          fields: _vm.fields,
                                          items:
                                            _vm.employee_leave_balance_items,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("b-pagination", {
                                staticClass: "my-0",
                                attrs: {
                                  "total-rows": _vm.totalRows,
                                  "per-page": _vm.perPage,
                                  align: "center",
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.currentPage,
                                  callback: function ($$v) {
                                    _vm.currentPage = $$v
                                  },
                                  expression: "currentPage",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("b-form-group", [
                            _vm._v(
                              " Showing " +
                                _vm._s(
                                  _vm.totalRows > 0
                                    ? _vm.perPage * (_vm.currentPage - 1) + 1
                                    : 0
                                ) +
                                " to " +
                                _vm._s(
                                  _vm.totalRows > 0
                                    ? Math.min(
                                        _vm.perPage * _vm.currentPage,
                                        _vm.totalRows
                                      )
                                    : 0
                                ) +
                                " of " +
                                _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                                " entries "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }